<div *ngIf="model?.listCalendars?.length > 0" class="container-fluid my-4 px-0 px-lg-3">
  <main [ngClass]="{'enlargeContainer': enlargeContainer}">
    <div #grid class="grid">
      <ng-container *ngIf="model.dayByWeek === 1">
        <div class="w-100 dailyTh q-bold">{{model?.listCalendars[0].body.startDate | DayOfQueovalDate: indParam.AppParams.culture: 'short':0}} {{model?.listCalendars[0].body.startDate | NumberOfQueovalDay: 0}}</div>
      </ng-container>
      <div #gridHeader class="grid-header">
        <div class="scrollable"
             *ngIf="model?.listCalendars[0].body?.weeklyRows?.length > 0"
             style.min-width.px="{{105 * (model?.listCalendars[0].body.weeklyRows.length  > 1 ? model.totalDays : model?.listCalendars[0].body.weeklyRows[0].cols.length)}}">
          <table>
            <colgroup>
              <ng-container *ngIf="model?.listCalendars && model?.listCalendars?.length > 0 && model?.listCalendars[0]?.body?.weeklyRows && model?.listCalendars[0]?.body?.weeklyRows?.length > 0">

                <ng-container *ngFor="let col of model?.listCalendars[0].body.weeklyRows; let iWeek = index; trackBy: trackWeeklyRows">
                  <ng-container *ngFor="let col of model?.listCalendars[0].body.weeklyRows[iWeek].cols; let i = index; trackBy: trackWeeklyCols">
                    <col />
                  </ng-container>

                </ng-container>
              </ng-container>
            </colgroup>

            <thead>
              <tr>
                <th style.flex="1 1 230px" class="locked-col">
                  <button class="q-btn q-main m-1" (click)="ExportToXls()" title="exporter vers Excel"><i class="fas fa-file-excel"></i></button>
                  <label class="m-0">
                    <ng-container *ngIf="model?.listCalendars && model?.listCalendars?.length > 0 && model?.listCalendars[0]?.body?.WeekNumbers && model?.listCalendars[0]?.body?.WeekNumbers?.length > 0">
                      <span>Semaine{{model?.listCalendars[0].body.WeekNumbers.length > 1 ? 's' : ''}} {{model?.listCalendars[0]?.body?.WeekNumbers[0]}} {{model?.listCalendars[0].body.WeekNumbers.length > 1 ? '- ' + model?.listCalendars[0]?.body?.WeekNumbers[model?.listCalendars[0].body.WeekNumbers.length - 1] : ''}}</span>
                    </ng-container>
                  </label>
                  <div class="grab-zone"></div>
                </th>
                <ng-container *ngIf="model?.listCalendars && model?.listCalendars?.length > 0 && model?.listCalendars[0]?.body?.weeklyRows && model?.listCalendars[0]?.body?.weeklyRows?.length > 0">
                  <ng-container *ngFor="let col of model?.listCalendars[0].body.weeklyRows; let iWeek = index; trackBy: trackWeeklyRows">
                    <ng-container *ngFor="let col of model?.listCalendars[0].body.weeklyRows[iWeek].cols; let i = index; trackBy: trackWeeklyCols">

                      <th style.flex="1 1 calc({{100 / model.dayByWeek}}% - {{230 / model.dayByWeek}}px)"
                          style.width="calc({{100 / model.dayByWeek}}% - {{230 / model.dayByWeek}}px)">
                        <label class="m-0">
                          <span *ngIf="model.dayByWeek !== 1">{{model?.listCalendars[0].body.startDate | DayOfQueovalDate: indParam.AppParams.culture: 'short': CalculatedIndex(iWeek, i)}} {{model?.listCalendars[0].body.startDate | NumberOfQueovalDay:  CalculatedIndex(iWeek, i)}}</span>
                          <span *ngIf="model.dayByWeek === 1">{{i}}h</span>
                        </label>
                      </th>
                    </ng-container>
                  </ng-container>
                </ng-container>

              </tr>
            </thead>
          </table>
        </div>
      </div>

      <div #gridBody class="grid-body" (scroll)="SetPosition(); DisplayEvent()">
          <div class="scrollable"
               *ngIf="model?.listCalendars[0].body?.weeklyRows?.length > 0"
               style.min-width.px="{{105 | planningMinWidth: model?.listCalendars[0].body.weeklyRows.length: model.totalDays: model?.listCalendars[0].body.weeklyRows[0].cols.length}}">

            <table style="box-shadow: 0px 1px 0 0 #c4c4c4;">
              <colgroup>
                <ng-container *ngIf="model?.listCalendars && model?.listCalendars?.length > 0 && model?.listCalendars[0]?.body?.weeklyRows && model?.listCalendars[0]?.body?.weeklyRows?.length > 0">
                  <ng-container *ngFor="let col of model?.listCalendars[0].body.weeklyRows; let iWeek = index; trackBy: trackWeeklyRows">
                    <ng-container *ngFor="let col of model?.listCalendars[0].body.weeklyRows[iWeek].cols; let i = index; trackBy: trackWeeklyCols">
                      <col />
                    </ng-container>

                  </ng-container>
                </ng-container>
              </colgroup>
              <tbody #container *ngIf="model?.listCalendars?.length > 0 && model?.listCalendars[0]?.body?.weeklyRows && model?.listCalendars[0]?.body?.weeklyRows?.length > 0">
                <tr *ngFor="let calendar of model?.listCalendars; let index = index; trackBy: trackCalendar"
                    [style.height.px]="calendar.height">
                  <ng-container >
                    <!--#region carte User-->
                    <td class="locked-col"
                        [style.z-index]="'user' | zIndex : model.dayByWeek: model.totalDays">
                      <div class="col-12 px-0">
                        <div *ngIf="calendar.header.userImage !== ''" class="card ispointer w-100">
                          <div class="card-horizontal d-flex"  title="{{calendar.header.userName}} {{calendar.header.userBureau}}">
                            <div class="text-center h-100 d-none d-md-flex  align-items-center ml-2">
                              <img class="rounded-circle" [src]="calendar.header.userImage | safe" alt="" style="width:60px!important; height:60px!important;">
                            </div>
                            <div class="mt-2">
                              <span class="d-flex px-1 align-items-center" style="font-size:.8rem;">{{calendar.header.userName}}</span>
                              <span class="d-flex px-1 align-items-center" style="font-size:.6rem;">{{calendar.header.userBureau}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <!--#endregion-->
                    <ng-container *ngFor="let row of model?.listCalendars[0].body.weeklyRows; let iWeek = index; trackBy: trackWeeklyRows">
                      <ng-container *ngFor="let col of model?.listCalendars[0].body.weeklyRows[iWeek].cols; let i = index; trackBy: trackWeeklyCols">
                        <td #gridCells [style.z-index]="'card' | zIndex : model.dayByWeek: model.totalDays: iWeek: model.listCalendars[0].body.weeklyRows[0].cols.length: i"
                            [style.background-color]="!calendar?.body?.weeklyRows[iWeek].cols[i].IsWorkingDay ? '#ccccff' : ''"
                            [style.border]="!calendar?.body?.weeklyRows[iWeek].cols[i].IsWorkingDay ? '1px solid white' : ''"
                            [ngClass]="{'current-date': CompareDates(CalculatedIndex(iWeek, i)) && model.dayByWeek !== 1, 'drag-over': dragStart && dragColId === CalculatedIndex(iWeek, i)  && calendarIndex === index}"
                            (click)="OpenModal(CalculatedIndex(iWeek, i),index)"
                            (drop)="onDrop($event, CalculatedIndex(iWeek, i), index)"
                            (dragover)="allowDrop($event, CalculatedIndex(iWeek, i), index)"
                            id="{{index}}-{{iWeek}}-{{i}}">
                          <!--<div [style.height.px]="calendar.height">
                      <div class="position-relative" [style.height.px]="calendar.body.weeklyRows[iWeek].height">-->
                          <ng-container *ngIf="model?.listCalendars && model?.listCalendars?.length > 0 && calendar?.body?.weeklyRows && model?.listCalendars[0]?.body?.weeklyRows?.length > 0 && model?.listCalendars[0]?.body?.weeklyRows[iWeek].cols?.length > i">
                            <ng-container *ngFor="let event of calendar?.body?.weeklyRows[iWeek].cols[i].events; let iMonthEvent = index; trackBy: trackWeeklyEvents">
                              <ng-container *ngIf="event.display">
                                <ng-container *ngIf="!event.isAnonimized && event.isMain">
                                  <div class="event position-absolute {{event.clipPath}}"
                                       [draggable]="event?.isUpdatable"
                                       (dragover)="DisableDrop($event)"
                                       (dragend)="DragEnd();"
                                       (dragstart)="dragEvent(event)"
                                       [ngClass]="{'q-cursor-default': !event.isReadable && !event.isUpdatable}"
                                       [style.border-left-color]="event.borderColor"
                                       [style.background-color]="event.color"
                                       [style.width]="event.width"
                                       [style.height]="event.height"
                                       [style.left]="event.left"
                                       [style.top]="event.top"
                                       placement="top"
                                       [ngbPopover]="!dragStart ? popContentModale : ''"
                                       popoverClass="agenda-affiche"
                                       container="body"
                                       triggers="mouseenter:mouseleave"
                                       (mouseenter)="OnMouseEnter(event, calendar.calendarGroupId);"
                                       (mouseleave)="OnMouseLeave()"
                                       (click)="EmitEvent(event)">
                                    <div>
                                      <ng-container *ngIf="!event.isMultiDay">
                                        {{event.startDate.heures}}:{{event.startDate.minutes}}
                                        -
                                        {{event.endDate.heures}}:{{event.endDate.minutes}}
                                      </ng-container>
                                      <ng-container *ngIf="event.isMultiDay">
                                        {{event.startDate.jour}} {{event.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{event.startDate.annee}} -
                                        {{event.endDate.jour}} {{event.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{event.endDate.annee}}
                                      </ng-container>
                                    </div>
                                    <div>{{event.label}}</div>
                                    <div>
                                      {{event.valueEVE}}
                                    </div>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="event.isAnonimized && event.isMain">
                                  <div class="event position-absolute q-cursor-default {{event.clipPath}}"
                                       (dragover)="DisableDrop($event)"
                                       [style.border-left-color]="event.borderColor"
                                       [style.background-color]="event.color"
                                       [style.width]="event.width"
                                       [style.height]="event.height"
                                       [style.left]="event.left"
                                       [style.top]="event.top"
                                       placement="top"
                                       [ngbPopover]="!dragStart ? popContentModale : ''"
                                       popoverClass="agenda-affiche"
                                       container="body"
                                       triggers="mouseenter:mouseleave"
                                       (mouseenter)="OnMouseEnter(event, calendar.calendarGroupId);"
                                       (mouseleave)="OnMouseLeave()"
                                       (click)="EmitEvent(event)">
                                    <div>
                                      {{event.startDate.heures}}:{{event.startDate.minutes}}
                                      -
                                      {{event.endDate.heures}}:{{event.endDate.minutes}}
                                    </div>
                                    <div>Privé</div>
                                  </div>
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                          <!--</div>
                      </div>-->
                        </td>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tr>

              </tbody>
            </table>

          </div>
      </div>
    </div>
  </main>
</div>

<ng-template #popContentModale>
  <ng-container *ngIf="contextEvent && contextEvent?.isMultiDay">
    <div class="q-header-popover">
      <div class="q-object-popover">{{ !contextEvent?.isAnonimized ? contextEvent.label : 'Privé'}}</div>
      <div class="q-hour-popover">
        {{contextEvent.startDate.jour}} {{contextEvent.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.startDate.annee}}
        -
        {{contextEvent.startDate.heures}}:{{contextEvent.startDate.minutes}}
      </div>
      <div class="q-hour-popover">
        {{contextEvent.endDate.jour}} {{contextEvent.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.endDate.annee}}
        -
        {{contextEvent.endDate.heures}}:{{contextEvent.endDate.minutes}}
      </div>
    </div>
    <div class="q-body-popover">
      <ng-container *ngIf="!contextEvent.isAnonimized">
        <ng-container *ngIf="LoadInfos">
          <div class="w-100 d-flex justify-content-center mt-1"><i class="q-c-main fas fa-spinner fa-pulse"></i></div>
        </ng-container>
        <ng-container *ngIf="!LoadInfos">
          <div *ngFor="let info of contextEvent.infos" class="w-100">
            <span class="q-c-main">{{info.key}} : </span>
            <span>{{info.value}}</span>
          </div>
        </ng-container>
      </ng-container>
</div>
  </ng-container>
  <ng-container *ngIf="contextEvent && !contextEvent?.isMultiDay">
    <div class="q-header-popover">
      <div class="q-object-popover">{{ !contextEvent?.isAnonimized ? contextEvent.label : 'Privé'}}</div>
      <div class="q-hour-popover">
        {{contextEvent.startDate.jour}} {{contextEvent.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.startDate.annee}}
        -
        {{contextEvent.startDate.heures}}:{{contextEvent.startDate.minutes}}
        -
        {{contextEvent.endDate.heures}}:{{contextEvent.endDate.minutes}}
      </div>
    </div>
    <div class="q-body-popover">
      <ng-container *ngIf="!contextEvent.isAnonimized">
        <ng-container *ngIf="LoadInfos">
          <div class="w-100 d-flex justify-content-center mt-1"><i class="q-c-main fas fa-spinner fa-pulse"></i></div>
        </ng-container>
        <ng-container *ngIf="!LoadInfos">
          <div *ngFor="let info of contextEvent.infos" class="w-100">
            <span class="q-c-main">{{info.key}} : </span>
            <span>{{info.value}}</span>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
